import { SubmissionError } from '#helper/submission-error';
import {
  FETCH_SHIPMENT_DELIVERY,
  SET_DISPLAY_FIELDS,
  CLEAR_DISPLAY_FIELDS
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { fetchAdditions, snackBarError } from '#action/fetch';
import { getRequestOptions } from '#helper';

export const fetchDelivery = id =>
  dispatch =>
    dispatch(fetchAdditions(`shipment/${id}/delivery`, FETCH_SHIPMENT_DELIVERY));

export const postDelivery = (id, states) => async dispatch => {
  const res = await fetch(webPortalApi.buildApiUrl(`shipment/${id}/delivery`), {
    method: 'POST',
    body: JSON.stringify(states),
    ...getRequestOptions()
  });
  const response = await res.json();

  if (!res.ok) {
    dispatch(
      snackBarError({
        message: 'Error in request',
        ...response
      })
    );
    throw new SubmissionError(response);
  }

  return { success: true };
};

export const editDelivery = (id, states) => async dispatch => {
  const res = await fetch(webPortalApi.buildApiUrl(`shipment/${id}/delivery`), {
    method: 'PUT',
    body: JSON.stringify(states),
    ...getRequestOptions()
  });
  const response = await res.json();

  if (!res.ok) {
    dispatch(
      snackBarError({
        message: 'Error in request',
        ...response
      })
    );
    throw new SubmissionError(response);
  }

  return { success: true };
};

export const setDisplayFields = states => (dispatch, getState) => {
  const current = getState().delivery;
  if (JSON.stringify(current) === JSON.stringify(states)) {
    return;
  }

  dispatch({
    type: SET_DISPLAY_FIELDS,
    payload: states
  });
};

export const clearDisplayFields = () => dispatch =>
  dispatch({
    type: CLEAR_DISPLAY_FIELDS
  });
